import React from "react";

const About = () => {
  return (
    <>
      <section class="about">
        <div class="container" data-aos="fade-up">
          <div class="row gx-0">
            <div
              class="col-lg-6 d-flex flex-column justify-content-center"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div class="content">
                <h3>Who We Are</h3>
                <h2>
                  Expedita voluptas omnis cupiditate totam eveniet nobis sint
                  iste. Dolores est repellat corrupti reprehenderit.
                </h2>
                <p>
                  Quisquam vel ut sint cum eos hic dolores aperiam. Sed deserunt
                  et. Inventore et et dolor consequatur itaque ut voluptate sed
                  et. Magnam nam ipsum tenetur suscipit voluptatum nam et est
                  corrupti.
                </p>
                <div class="text-center text-lg-start">
                  <button className="btn-now">Discover More</button>
                </div>
              </div>
            </div>

            <div
              class="col-lg-6 mt-3"
              data-aos="zoom-out"
              data-aos-delay="200"
            >
              <img
                src="assets/img/c2.jpeg"
                class="img-fluid"
                alt="This is About Us Iamge "
              />
            </div>
          </div>
        </div>
      </section>
      <section id="values" class="values">
        <div class="container" data-aos="fade-up">
          <header class="section-header">
            <h2 className="sh4">DELICIOUS RECIPES</h2>
          </header>

          <div class="row">
            <div class="col-lg-4">
              <div class="box">
                <img src="assets/img/values-1.jpg" class="img-fluid" />
                <h3 className="sh4">Brownies and Coffee</h3>
                <p>
                  Quis autem velis et reprehender etims quiste voluptate velit
                  esse quam nihil etsa illum sedit consequatur quias voluptas
                  sit netsum.
                </p>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="box">
                <img src="assets/img/values-2.jpg" class="img-fluid" alt="" />
                <h3 className="sh4">Oldest London Pub</h3>
                <p>
                  Quis autem velis et reprehender etims quiste voluptate velit
                  esse quam nihil etsa illum sedit consequatur quias voluptas
                  sit netsum.
                </p>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="box">
                <img src="assets/img/values-3.jpg" class="img-fluid" alt="" />
                <h3 className="sh4">New Cooking Recipes</h3>
                <p>
                  Quis autem velis et reprehender etims quiste voluptate velit
                  esse quam nihil etsa illum sedit consequatur quias voluptas
                  sit netsum.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
